module.exports = __webpack_public_path__ + "static/media/OpenSans.79515ad0.woff";